import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404 - Page Not Found</h1>
      <p style={styles.text}>Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" style={styles.link}>Go Back Home</Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center" as const,
    marginTop: "50px",
  },
  heading: {
    fontSize: "2rem",
    color: "#d32f2f",
  },
  text: {
    fontSize: "1.2rem",
    marginBottom: "20px",
  },
  link: {
    textDecoration: "none",
    color: "#1976d2",
    fontSize: "1.2rem",
  },
};

export default NotFound;